import {Component, OnInit, AfterViewInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {DecimalPipe} from "@angular/common";
import {HeizcheckAnfrage} from "../anfrage/heizcheck.anfrage";
import {VerbrauchsanalyseHeizcheckForm} from "../verbrauchsanalyse/verbrauchsanalyse.heizcheck.form";
import {HeizcheckRequestService} from "../services/heizcheck-request.service";
import {TranslateService} from "@ngx-translate/core";
import {EmbedService} from "../../services/embed.service";
import {ModeratRequestService} from "../../moderat/services/request.service";
import {EnergyMapService} from '../../energy-map/services/energy.map.service';

/**
 * Special component for the result page of the hec
 */
@Component({
    selector: 'app-heizcheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class ErgebnisComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   *
   */
  anfrage: HeizcheckAnfrage;

  /**
   * indicator if a result is avaibalbe
   */
  hasResult: boolean = false;

  /**
   * the object of the result, from anfrge object
   */
  result: any;

  /**
   * some placeholders for the texts
   */
  placeholder: {};

  /**
   * The satge that we need for the texts
   */
  stage: number = null;

  /**
   * more simple satge, indicating -1 (below avg), 0 (avg) or +1 (more than avg)
   */
  simpleStage: string = null;

  /**
   * toggle for the building type/image
   */
  apartementBuilding: boolean = false;

  /**
   * Toggle if an apartement is checked. If false, a building is given for the check
   */
  isApartement: boolean = false;

  /**
   * If true, mark a floor in apartement building. If false, do not mark.
   */
  markApartement: boolean = false;

  /**
   * toggle if we show information about extra costs
   */
  hasExtracosts: boolean = false;

  /**
   * Toggle if we show information about warm water
   */
  hasWarmwater: boolean = false;

  /**
   * toggle if the energy source is fossil (oil, gas)
   */
  isFossilEnergySource: boolean = false;

  /**
   * Toogle for showhing/hiding hints
   */
  hints: {[key: string]: boolean} = {avg: false, costs: false, estimate: false, forecast: false};

  /**
   * Data for comparing the actual costs with the future estimation
   */
  compareData: {average: {value: number, percent: number}, costs: {value: number, percent: number, heating: number, water: number, waterPercent: number}, estimate: {value: number, percent: number}};

  /**
   * list of data for the forcast years
   */
  forecastData: {
    market: { year: string, energy: number, co2: number, costs: number, extraCosts: number, percentage?: number }[],
    real: { year: string, energy: number, co2: number, costs: number, extraCosts: number, percentage?: number }[],
    activeType: 'market' | 'real'
  } = {market: [], real: [], activeType: 'real'};

  /**
   * The stages for some cost of the user
   */
  stages: {energyprice: string, warmwater: string, extracosts: string, headline: string, teaser: string} = {energyprice: '0', extracosts: 'nodata', warmwater: '0', headline: '', teaser: ''};

  /**
   * toggle if the user is using the building/apartement on its own or not
   */
  selfUser: boolean = false;

  /**
   * URL for showing the MOC
   */
  mocUrls: {plain: string, secondChapter: string};

  /**
   * toggle if this is an internal portalId or not
   */
  internalPortal: boolean = false;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * holds the data that we need for the dialogform.
   */
  dialogData: any = {};

  /**
   * HOlds the reportUrl if the report is offered as download
   */
  reportUrl: string = null;

  /**
   * hold the visible tipps
   */
  tipps: {name: string, icon: string, url: string}[];

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = '../../verbrauchsanalyse/verbrauchsdaten';

  /**
   * holds the id of the html element where to jump to after click on dialog hint
   */
  idTargetElement: string = null;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * set to true if we want to display the moc teaser
   */
  familyHouseDezentral2: boolean;

  /**
   * toggle if the energy source is district heating
   */
  isDistrictHeating: boolean = false;

  /**
   * data for different cases to show different info texts
   */
  dataCases: {stages: any, isApartement: boolean, hasWarmwater: boolean, isMfhOwnerCentralHeating: boolean, isFossilEnergySource: {fossil: boolean, gas: boolean, oil: boolean}, isDistrictHeating: boolean};

  /**
   * @inheritDoc
   *
   * @param stepService
   * @param router
   * @param requestService
   * @param elementService
   * @param portalService
   * @param decimalPipe
   * @param translate
   * @param embedService
   * @param moderatRequestService
   * @param energyMapService
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: HeizcheckRequestService, protected elementService: ElementService,
              protected portalService: PortalService, private decimalPipe: DecimalPipe, private translate: TranslateService, private embedService: EmbedService,
              private moderatRequestService: ModeratRequestService, protected energyMapService: EnergyMapService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    // add the correct form config that we need in this steps and init the parent form
    this.formConfig = new VerbrauchsanalyseHeizcheckForm(this.energyMapService);
    super.ngOnInit();

    // get the current input data and preset it
    this.anfrage = this.requestService.getAnfrage();
    this.formConfig.setData(this.anfrage.verbrauchsanalyseInput);

    // update the previous step
    this.onStepUpdate();

    // check if the user uses  building/apartement on its own
    this.selfUser = !(this.anfrage.verbrauchsanalyseInput.gebaeudetyp === 'mehrfamilienhaus' && ['hausverwalter', 'hauseigentuemer'].indexOf(this.anfrage.verbrauchsanalyseInput.nutzungstyp) > -1);

    // check if the current portal is internal
    this.internalPortal = this.portalService.isInternalPortal();
    this.hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');

    // set report URL for download
    this.reportUrl = this.anfrage.verbrauchsanalyseResult?.report?? null;

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');
    this.showDownload = !this.hideReportDownload && this.reportUrl && !this.internalPortal;
    this.initDialogData();

    //add css class to dialog or download module
    if(this.forceDialog) {
      this.idTargetElement = 'lead';
    }
    else if(this.showDownload) {
      this.idTargetElement = 'download';
    }

    // initialize the tipps
    this.initTipps();

    // check if there is a result that we can show
    if(this.anfrage.verbrauchsanalyseResult.hasOwnProperty("status") && this.anfrage.verbrauchsanalyseResult.status.code === 0) {
      this.isApartement = this.formConfig.getField('wohnung_flaeche').isActive();
      this.hasWarmwater = typeof this.anfrage.verbrauchsanalyseResult?.ratings?.warmwater !== "undefined";
      this.isFossilEnergySource = this.anfrage.verbrauchsanalyseResult.data.prognose?.co2_kosten?.aktuell.kosten > 0;
      this.isDistrictHeating = this.anfrage.verbrauchsanalyseInput.energietraeger_name === 'fernwaerme';
      this.hasResult = true;
      this.result = this.anfrage.verbrauchsanalyseResult.data.durchschnitt;

      // set the report URL
      this.reportUrl = this.anfrage.verbrauchsanalyseResult.report?? null;

      // set the image type
      this.apartementBuilding = this.anfrage.verbrauchsanalyseInput.gebaeudetyp === 'mehrfamilienhaus';

      // based on user input, we mark floor in apartement
      this.markApartement = this.anfrage.verbrauchsanalyseInput.nutzungstyp === 'wohnungseigentuemer' && this.anfrage.verbrauchsanalyseInput.heizungstyp === 'dezentral';

      // hide moc teaser in case family house with heating type dezentral2 (nachtspeicher)
      this.familyHouseDezentral2 = this.anfrage.verbrauchsanalyseInput.gebaeudetyp !== this.apartementBuilding && this.anfrage.verbrauchsanalyseInput.heizungstyp === 'dezentral2'

      // get the estimation columns from portal config
      const years = this.portalService.getConfig("heizcheck.prognose.jahre");
      const columnYear = this.portalService.getConfig("heizcheck.prognose.balken");
      let estimationYearColumn = 1;
      if(typeof years === "string" && years?.length > 0 && typeof columnYear === "string" && columnYear?.length > 0) {
        const yearList = years.split(",");
        if(yearList.length > 0 && yearList.indexOf(columnYear) > -1) {
          estimationYearColumn = yearList.indexOf(columnYear);
        }
      }

      // prepare some placeholder for the texts, merge them with backend placeholders
      const backendPlaceholder = this.anfrage.verbrauchsanalyseResult.placeholder?? {};
      this.placeholder = {...backendPlaceholder, ...{
        year: (new Date()).getFullYear(),
        lastyear: this.anfrage.verbrauchsanalyseResult.data.letzte.abrechnungsjahr,
        year5: this.anfrage.verbrauchsanalyseResult.data.prognose?.energiekosten?.zukunft[estimationYearColumn]?.jahr?? ''
      }};

      // get the energy source label for the textstore
      const energySourceName = this.anfrage.verbrauchsanalyseInput.energietraeger_name.match(/waermepumpe/)? 'strom' : this.anfrage.verbrauchsanalyseInput.energietraeger_name;
      const labelEnergySource = 'heizcheck.energietraeger_name.' + energySourceName + '.label';

      // based on the users input, we need some placeholder from the translation bundle
      this.translate.get(['heizcheck.wohnungen', 'heizcheck.gebaeude', 'heizcheck.wohnung.ihr', 'heizcheck.gebaeude.ihr', labelEnergySource]).subscribe(data => {
        this.placeholder['energietraeger'] = data[labelEnergySource];
        if(this.isApartement === true) {
          this.placeholder['gebaeude_wohnungen'] = data['heizcheck.wohnungen'];
          this.placeholder['gebaeude_wohnung'] = data['heizcheck.wohnung'];
          this.placeholder['ihr_gebaeude_wohnung'] = data['heizcheck.wohnung.ihr'];
        }
        else {
          this.placeholder['gebaeude_wohnungen'] = data['heizcheck.gebaeude'];
          this.placeholder['gebaeude_wohnung'] = data['heizcheck.gebaeude'];
          this.placeholder['ihr_gebaeude_wohnung'] = data['heizcheck.gebaeude.ihr'];
        }
      });

      // data for comparing costs to estimation
      const estimation = (this.anfrage.verbrauchsanalyseResult.data.prognose?.energiekosten?.zukunft[estimationYearColumn]?.kosten?? 0) +
        (this.anfrage.verbrauchsanalyseResult.data.prognose?.co2_kosten?.zukunft[estimationYearColumn]?.kosten?? 0) +
        (this.anfrage.verbrauchsanalyseResult.data.prognose?.heiznebenkosten?.zukunft[estimationYearColumn]?.kosten?? 0);

      this.compareData = {
        costs: {
          value: this.anfrage.verbrauchsanalyseResult.data.prognose.gesamtkosten_real.aktuell.kosten ?? this.anfrage.verbrauchsanalyseResult.data.letzte.heizkosten_gesamt_jahr ?? null,
          percent: 0.5,
          heating: this.anfrage.verbrauchsanalyseResult.data.letzte.heizkosten_raumwaerme_jahr?? this.anfrage.verbrauchsanalyseResult.data.letzte.energiekosten_raumwaerme_jahr?? null,
          water: this.anfrage.verbrauchsanalyseResult.data.letzte.heizkosten_warmwasser_jahr?? this.anfrage.verbrauchsanalyseResult.data.letzte.energiekosten_warmwasser_jahr?? null,
          waterPercent: 0
        },
        average: {value: this.anfrage.verbrauchsanalyseResult.data.prognose.gesamtkosten_durchschnitt.aktuell.kosten ?? this.anfrage.verbrauchsanalyseResult.data.letzte.heizkosten_durchschnitt_jahr?? null, percent: 0.5},
        estimate: {value: Math.round(estimation / 10) * 10, percent: 0.5}
      };

      /*
       * stages, based on the costs
       */
      this.stages = {energyprice: '0', extracosts: 'nodata', warmwater: '0', headline: '', teaser: ''};

      // energy-price
      this.stages.energyprice = this.anfrage.verbrauchsanalyseResult?.ratings?.energyprice?? '0';

      // set stage for extracosts
      this.stages.extracosts = this.anfrage.verbrauchsanalyseResult?.ratings?.extracosts?? 'nodata';

      // set stage for warmwater
      this.stages.warmwater = this.anfrage.verbrauchsanalyseResult?.ratings?.warmwater?? '0';

      // set forecast data
      if(Object.keys(this.anfrage.verbrauchsanalyseResult?.data?.prognose).length > 0) {
        const prognose = this.anfrage.verbrauchsanalyseResult.data.prognose;
        this.forecastData.market = ErgebnisComponent.buildForcastData(prognose, 'durchschnitt', 'zukunft');
        this.forecastData.real = ErgebnisComponent.buildForcastData(prognose, 'real', 'zukunft');

        setTimeout(() => this.updateBars(), 500);
      }
    }
    else {
      console.warn("no result to display");
    }

    if (this.energyMapService.showEnergyMap(this.anfrage, 'heizcheck') === true
        && this.energyMapService.isEnergyMapDataDonated(this.anfrage) === false
        && this.energyMapService.getEnergyMapConfirmDonation(this.anfrage) !== 'n'
        && this.energyMapService.getEnergyMapBuildingNotIncludedInMap(this.anfrage) !== true
    ) {
      this.lastStep = '/' + this.portalService.currentPortalId + '/heizcheck/verbrauchsanalyse/energy-map';
    }

    // different cases for the forecast chart component
    const energietraeger = this.anfrage.verbrauchsanalyseInput?.energietraeger_name;

    this.dataCases = {
      stages: this.stages,
      isApartement: this.isApartement,
      hasWarmwater: this.hasWarmwater,
      isMfhOwnerCentralHeating: this.anfrage.verbrauchsanalyseResult?.ratings?.mfh_central_heating_owner,
      isFossilEnergySource: {
        fossil: this.isFossilEnergySource,
        gas: energietraeger === 'erdgas',
        oil: energietraeger === 'heizoel'
      },
      isDistrictHeating: this.isDistrictHeating
    };
  }

  /**
   * Switches the displayed forecast data between market average and real prices (user input based).
   * Triggers a recalculation of the chart scale.
   */
  setForecastType(type: 'market' | 'real'): void {
    this.forecastData.activeType = type;

    // save active forecast type in the anfrage object
    const anfrage = this.requestService.getAnfrage();
    anfrage.verbrauchsanalyseInput.forecastType = type;
    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();

    // Recalculate percentages so the bars adjust to the new values
    this.updateBars();
  }

  /**
   * Build the forcast data for the result chart
   * @param data
   * @param futureIndex
   * @param forecastType
   */
  static buildForcastData(data: any, forecastType: 'durchschnitt' | 'real', futureIndex: 'zukunft' | 'zukunft_wohnung'): any {
    const forecastData: any = [];

    const energyKey = 'energiekosten_' + forecastType;
    const extraCostsKey = 'heiznebenkosten_' + forecastType;

    // Verify that the requested data set exists before iterating
    if (!data[energyKey] || !data[energyKey][futureIndex]) {
      return [];
    }

    data[energyKey][futureIndex].forEach(row => {
      const co2 = data.co2_kosten?.[futureIndex][forecastData.length]?.kosten ?? 0;
      const extraCosts = data[extraCostsKey][futureIndex][forecastData.length]?.kosten ?? 0;
      const energy = row.kosten;
      const costsPercent = data.gesamtkosten_real?.zukunft_wohnung?.[forecastData.length]?.anteil_prozent ?? null;

      forecastData.push({
        energy: energy / (energy + co2),
        year: row.jahr,
        co2: co2 / (energy + co2),
        costs: futureIndex === 'zukunft_wohnung' ? costsPercent : this.roundForecastCosts(energy + co2 + extraCosts),
        extraCosts: extraCosts,
      });
    });

    return forecastData;
  }

  /**
   * Rounds forecast costs dynamically based on its scale (5, 10, 100, or 1000)
   * @param costs
   */
  static roundForecastCosts(costs) {
    if (costs < 100) return Math.round(costs / 5) * 5;
    if (costs < 10000) return Math.round(costs / 10) * 10;
    if (costs < 100000) return Math.round(costs / 100) * 100;
    return Math.round(costs / 1000) * 1000;
  }

  /**
   * Update the bars height
   */
  updateBars(): void {
    // get the active forecast data
    const activeForecastData = this.forecastData[this.forecastData.activeType];

    // define the base value which is always the input costs as 100%
    const baseValue = this.compareData.costs.value;

    if (baseValue > 0) {
      // define visual scale factor so the base value bar is always 70% of the containers total height. We get some space reserved for the higher forecast bars which can be up to 142,9% (1/0.7)
      const visualScale = 0.7;
      const topZone = 1 - visualScale;

      // get the highest forecast value
      const maxForecastValue = Math.max(...activeForecastData.map(value => value.costs));

      // difference between baseValue (100%) and the maximum forecast value
      const maxDifference = maxForecastValue - baseValue;

      // define comparative values where costs will get the visual 70%
      Object.keys(this.compareData).forEach(key => {
        const compareValue = this.compareData[key].value || 0;
        this.compareData[key].percent = (compareValue / baseValue) * visualScale;
      });

      // water percent is in relation to base value and does not need the visualScale factor
      this.compareData.costs.waterPercent = this.compareData.costs.water ? this.compareData.costs.water / this.compareData.costs.value : null;

      // define the relative percentage for each forecast bar, relative to the difference between base value and highest forecast value. so after switching to other forecast data the costs bar (base value) does not change height
      activeForecastData.forEach(data => {
        if (data.costs <= baseValue) {
          // case: one forecast value <= base value
          data.percentage = (data.costs / baseValue) * visualScale;
        }
        else if (maxDifference > 0) {
          // case: highest forecast value > base value, spread the difference between base value and forecast value proportionally over the topZone
          const currentDiff = data.costs - baseValue;
          const diffRatio = currentDiff / maxDifference;

          data.percentage = visualScale + (diffRatio * topZone);
        }
        else {
          // fallback: no increase and same height like base value
          data.percentage = visualScale;
        }
      });
    }
  }

  /**
   * Updates the stage value
   */
  setStage(stage: number) {
    this.stage = stage;

    // stage for the teasertext
    this.mocUrls = null;
    if(this.isApartement === true || (this.anfrage.verbrauchsanalyseInput.gebaeudetyp !== this.apartementBuilding && this.anfrage.verbrauchsanalyseInput.nutzungstyp === 'mieter')) {
      this.stages.teaser = 'wohnung';
      this.stages.teaser += this.stage > 1? '.+1' : '.0'
      this.stages.headline = 'wohnung';
    }
    else {
      if(this.anfrage.verbrauchsanalyseInput.gebaeude_denkmalschutz === 'ja') {
        this.stages.teaser = 'denkmalschutz';
        this.stages.headline = 'denkmalschutz';
      }
      else {
        this.stages.teaser = 'gebaeude';
        this.stages.headline = 'gebaeude';
        // show the button to the moc
        this.initMocUrl();
      }
      this.stages.teaser += this.isFossilEnergySource? '.fossil' : ''
      this.stages.teaser += this.stage > 1? '.+1' : '.0'
    }

    setTimeout(() => {
      // update simple stage
      this.simpleStage = '0';
      if(stage < 2) {
        this.simpleStage = '-1';
      }
      else if(stage > 2) {
        this.simpleStage = '+1';
      }
    }, 0)
  }

  /**
   * Initializes the MOC anfrage object and the URL that leads to the MOC
   */
  initMocUrl(): void {
    if(this.portalService.getConfig("alladvisors.link.modernisierungscheck")) {
      // nit the moc anfrage and session in the current browser
      const mocAnfrage = this.moderatRequestService.getAnfrage();
      mocAnfrage.verbrauchsanalyseInput = this.anfrage.verbrauchsanalyseInput;
      mocAnfrage.verbrauchsanalyseResult = this.anfrage.verbrauchsanalyseResult;
      mocAnfrage.bestandsanalyseInput = {};
      mocAnfrage.massnahmen = {}
      mocAnfrage.interesse = 'alles';
      this.moderatRequestService.setAnfrage(mocAnfrage);

      // reset requestId if there is one
      this.moderatRequestService.backendService.resetRequestId();

      // get the base URL
      this.mocUrls = {
        plain: this.portalService.getConfig("alladvisors.link.modernisierungscheck").replace(/\{\{portalId}}/, this.portalService.currentPortalId),
        secondChapter: this.portalService.getConfig("alladvisors.link.modernisierungscheck").replace(/\{\{portalId}}/, this.portalService.currentPortalId)
      };

      // add parameter to enter the second chapter
      this.mocUrls.secondChapter += this.mocUrls.secondChapter.match(/\?/)? "&" : "?";
      this.mocUrls.secondChapter += "step=chapter2";
    }
  }

  /**
   * initialize the tipps, based on the users type
   */
  initTipps(): void {
    // should the tipps always been hidden in the result page of this portal?
    if(this.portalService.getConfigAsBool('heizcheck.tipps.hide') === true) {
      return;
    }

    // is the building/apartment used by the user
    const isSelfUsage = (this.anfrage.verbrauchsanalyseInput.gebaeudetyp !== this.apartementBuilding && this.anfrage.verbrauchsanalyseInput.nutzungstyp === 'hauseigentuemer') ||
      (this.anfrage.verbrauchsanalyseInput.nutzungstyp === 'mieter' || this.anfrage.verbrauchsanalyseInput.nutzungstyp === 'wohnungseigentuemer');

    if(this.portalService.isInternalPortal() && isSelfUsage === true) {
      // internal & selfusage
      this.tipps = [
        {name: 'warmwasser', icon: 'save-water', url: 'https://www.co2online.de/energie-sparen/heizenergie-sparen/warmwasser/wasser-sparen-die-10-besten-tipps/'},
        {name: 'temperatur', icon: 'house-temperature', url: 'https://www.co2online.de/energie-sparen/heizenergie-sparen/heizkosten-sparen/richtig-heizen-die-10-besten-tipps/#c27389'},
        {name: 'lueften', icon: 'ventilate-time', url: 'https://www.co2online.de/energie-sparen/heizenergie-sparen/lueften-lueftungsanlagen-fenster/richtig-lueften/'}
      ];
    }
    else if (this.portalService.isInternalPortal() && isSelfUsage === false) {
      // internal & no selfusage
      this.tipps = [
        {name: 'fenster.eigentuemer', icon: 'window-seal', url: 'https://www.co2online.de/energie-sparen/heizenergie-sparen/lueften-lueftungsanlagen-fenster/fenster-abdichten-anleitung/'},
        {name: 'hydraulischerabgleich', icon: 'hydraulic-check', url: 'https://www.co2online.de/energie-sparen/heizenergie-sparen/hydraulischer-abgleich/'},
        {name: 'rohre', icon: 'pipe', url: 'https://www.co2online.de/modernisieren-und-bauen/sanierung-modernisierung/heizungsrohre-isolieren-anleitung/'}
      ];
    }
    else if(isSelfUsage === true) {
      // external and selfusage
      this.tipps = [
        {name: 'warmwasser.external', icon: 'save-water', url: null},
        {name: 'temperatur.external', icon: 'house-temperature', url: null},
        {name: 'lueften.external', icon: 'ventilate-time', url: null},
        {name: 'duschkopf.external', icon: 'shower-head', url: null},
        {name: 'thermostateexternal', icon: 'smart-thermostat', url: null},
        {name: 'fenster.mieter.external', icon: 'window-seal', url: null}
      ];
    }
    else {
      // external and no selfusage
      this.tipps = [
        {name: 'fenster.eigentuemer.external', icon: 'window-seal', url: null},
        {name: 'hydraulischerabgleich.external', icon: 'hydraulic-check', url: null},
        {name: 'rohre.external', icon: 'pipe', url: null},
        {name: 'smarthome.external', icon: 'smart-home', url: null}
      ];
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element)
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId: requestId,
        bmOptinSource: window.location.href,
        doisource: 'hec',
        path: 'hec'
      }
    });
  }

  /**
   * eventhandler, after the dialog registration is finished.
   * @param result
   */
  dialogRegistered(result): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }


  /**
   * Toggles the visibility of the hint box while closing all other hint boxes.
   * @param selectedKey
   */
  toggleHint(selectedKey: string): void {
    // current visibility state of the clicked item
    const currentState = this.hints[selectedKey];

    // 1. Reset all hints to false to ensure only one box is visible at a time
    Object.keys(this.hints).forEach(key => {
      this.hints[key] = false;
    });

    // 2. Toggle the clicked key based on its previous state
    this.hints[selectedKey] = !currentState;
  }
}
